const BH_VIDEO_URL = 'https://player.vimeo.com/video/369984788';

(($) => {
    $(document).ready(() => {
        let dataLoadComplete = new Event('dataLoadComplete');
        window.bhWP = {
            selectedCountry: undefined,

            stateCode: '',
            coupon_code: '',
            discount: 0,

            countryList: undefined,
            currentProductPrice: 0,
            userDataFilled: false,
            lastScrollTop: 0,
            loadStepCounter: 0,
            maxLoadStepCounter: 0,
            productsCache: {},

            plans: {},

            setPlanData: (plan) => {
                // do a calculation for prices
                let economy_price = window.bhWP.plans[plan]['Economy'].price;
                let business_price = window.bhWP.plans[plan]['Business Class'].price;
                let first_class_price = window.bhWP.plans[plan]['First Class'].price;

                if (plan === 'yearly') {
                    economy_price = (parseFloat(economy_price) / 12).toFixed(2);
                    business_price = (parseFloat(business_price) / 12).toFixed(2);
                    first_class_price = (parseFloat(first_class_price) / 12).toFixed(2);
                }

                $('#plan__economy .price-value').html(economy_price);
                $('#plan__business .price-value').html(business_price);
                $('#plan__first-class .price-value').html(first_class_price);

                $('#plan__economy .price-monthly .price-value').html(window.bhWP.plans['monthly']['Economy'].price);
                $('#plan__business .price-monthly .price-value').html(
                    window.bhWP.plans['monthly']['Business Class'].price
                );
                $('#plan__first-class .price-monthly .price-value').html(
                    window.bhWP.plans['monthly']['First Class'].price
                );

                if (plan === 'monthly') {
                    $('#plan_list').addClass('monthly');
                    $('#plan_list').removeClass('yearly');
                } else {
                    $('#plan_list').removeClass('monthly');
                    $('#plan_list').addClass('yearly');
                }

                // build feature list
                $('#plan__economy .feature-list').html(() => {
                    let output = '';
                    window.bhWP.plans[plan]['Economy'].features.forEach((v) => {
                        output += `<li>${v}</li>`;
                    });
                    return output;
                });
                $('#plan__business .feature-list').html(() => {
                    let output = '';
                    window.bhWP.plans[plan]['Business Class'].features.forEach((v) => {
                        output += `<li>${v}</li>`;
                    });
                    return output;
                });
                $('#plan__first-class .feature-list').html(() => {
                    let output = '';
                    window.bhWP.plans[plan]['First Class'].features.forEach((v) => {
                        output += `<li>${v}</li>`;
                    });
                    return output;
                });
            },

            getFiltered: function (name, data) {
                let filtered = [],
                    regex = new RegExp('^' + window.bhWP.escapeRegExp(name.toLowerCase()));

                for (let key in data) {
                    //eslint-disable-next-line
                    if (regex.test(he.decode(data[key]).toLowerCase())) {
                        filtered[key] = data[key];
                    }
                }

                return filtered;
            },
            sendConversionInitCheckout: function () {
                var current_page = window.location.href;
                var reqData = {
                    action: 'initiate_checkout',
                    current_page: current_page,
                };

                $.post(wp.ajax_url, reqData, () => {}, 'json').done((resp) => {});
            },
            displayShippingMethods: function (display = false) {
                // Display total and show checkout button
                if (display) {
                    $('.user-details-wrap').fadeOut({
                        complete: () => $('.go-to-checkout').fadeIn(),
                    });
                } else {
                    $('.go-to-checkout').fadeOut({
                        complete: () => $('.user-details-wrap').fadeIn(),
                    });
                }
            },
            formatDelivery: function (delivery) {
                let days = delivery.match(/^\d+-\d+/g);
                if (days === null) {
                    return '';
                }
                return days + ' days';
            },
            calculatePrice: function () {
                let shippingCost = 0,
                    price;

                const isFlat = $('input[name=shipping]:checked').val() == 'flat_rate';
                const isPriority = $('input[name=shipping]:checked').val() == 'priority';
                if (isFlat) {
                    // shippingCost = +window.bhWP.selectedCountry.shipping.flat_price;
                    shippingCost = 0;
                } else if (isPriority) {
                    shippingCost = +window.bhWP.selectedCountry.shipping.priority_price;
                    if (shippingCost > 10) {
                      shippingCost -= 10;
                    }
                }
                const qty = $('input#product_qty').val() || 1;
                if (qty > 1 && isFlat) {
                    const halfPrice = Number(shippingCost) / 2;
                    shippingCost += halfPrice * (qty - 1);
                }
                price = Number(this.currentProductPrice) * qty - Number(this.discount) + Number(shippingCost);

                return price.toFixed(2);
            },
            dataLoaded: () => {
                window.bhWP.loadStepCounter++;
                if (window.bhWP.loadStepCounter >= window.bhWP.maxLoadStepCounter) {
                    $('.ajax-load-animation').fadeOut({
                        complete: () => $('.checkout-modal-content').fadeIn(),
                    });
                }
            },
            prepareToDataLoad: function () {
                this.maxLoadStepCounter++;

                $('.checkout-modal-content').css('display', 'none');
                $('.ajax-load-animation').css('display', 'flex');
            },
            goToSelectShipping: function () {
                if (!window.bhWP.countryList) {
                    return false;
                }
                if (!window.bhWP.selectedCountry) {
                    $('#error-country').html(
                        '<span class="help-block form-error">Please select a country from the list.</span>'
                    );
                    $('input#country').val('');
                    return false;
                }
                if (window.bhWP.selectedCountry.states && !window.bhWP.stateCode.replace(/\s/g, '')) {
                    $('#error-state').html(
                        '<span class="help-block form-error">Please select a state from the list.</span>'
                    );
                    $('input#state').val('').trigger('input');
                    // $('#states_list').trigger
                    return false;
                }

                if ($('input#phone').val().replace(/\s+/, '') && isNaN($('input#phone').val())) {
                    $('#error-phone').html('<span class="help-block form-error">Please enter a correct phone.</span>');
                    $('input#phone').val('');
                    return false;
                }

                let countryTitle = $('input#country').val();

                if (!countryTitle) {
                    return false;
                }

                window.bhWP.couponApplied = false;
                window.bhWP.discount = 0;
                $('#applied_coupon, #coupon').val('');
                $('.input-coupon input#coupon, .input-coupon button').prop('disabled', false);
                $('.input-shipping-type').prop('checked', false);

                $('#submit_paypal_btn, #submit_stripe_btn').show();

                const shipping = window.bhWP.selectedCountry.shipping;

                if (!shipping.flat_delivery || !shipping.flat_price) {
                    $('.input-flat-shipping').css('display', 'none');
                } else {
                    $('.shipping-desc#flat_price .shipping-desc-val').html(`$${shipping.flat_price}`);
                    $('.shipping-desc#flat_delivery .shipping-desc-val').html(
                        `${window.bhWP.formatDelivery(shipping.flat_delivery)}`
                    );
                }

                if (!shipping.priority_delivery || !shipping.priority_price) {
                    $('.input-priority-shipping').css('display', 'none');
                } else {
                    let price = shipping.priority_price;
                    if (price > 10) {
                      price -= 10;
                    }
                    $('.shipping-desc#priority_price .shipping-desc-val').html(`$${price}`);
                    $('.shipping-desc#priority_delivery .shipping-desc-val').html(
                        `${window.bhWP.formatDelivery(shipping.priority_delivery)}`
                    );
                }

                $('.shipping-title-country-name').html(countryTitle);

                const qtySet = $('#main_product_qty').val() || 1;
                $('input#product_qty').val(qtySet);

                // $('#total_cost').html(`$${window.bhWP.currentProductPrice}`);
                $('#total_cost').html(`$${window.bhWP.calculatePrice()}`);

                $('#checkout_form').scrollTop(0);

                window.bhWP.displayShippingMethods(true);
                window.bhWP.userDataFilled = true;
            },
            goToCheckout: function () {
                let formData = {};

                if (!$('.input-shipping-type').is(':checked')) {
                    $('#error-select-shipping').fadeIn();
                    $('form.checkout-form').scrollTop(0);
                    return false;
                }
                const quantity = Number($('input#product_qty').val());
                if (isNaN(quantity) || quantity < 1) {
                    $('#error-quantity').fadeIn();
                    $('form.checkout-form').scrollTop(0);
                    return false;
                }

                $('#checkout_form')
                    .serializeArray()
                    .forEach((element) => {
                        formData[element.name] = element.value;
                    });

                formData['country_id'] = '';

                if (window.bhWP.selectedCountry.country_id) {
                    formData['country_id'] = window.bhWP.selectedCountry.country_id;
                }
                formData['country_code'] = window.bhWP.selectedCountry.country_code;
                formData['state_code'] = window.bhWP.stateCode ? window.bhWP.stateCode : '';
                formData['current_page'] = window.location.href;

                let requestData = {
                    action: 'create_stripe_session',
                    formData: formData,
                };

                window.bhWP.prepareToDataLoad();

                $.post(wp.ajax_url, requestData, () => {}, 'json')
                    .done((resp) => {
                        if (!resp.result) {
                            document.body.dispatchEvent(dataLoadComplete);

                            return false;
                        }

                        const orderInfo = resp.order_info;

                        tap('conversion', orderInfo.order_id, orderInfo.price_without_ship, {
                            currency: orderInfo.currency,
                        });

                        const sessionId = resp.session_id,
                            stripe = Stripe(wp.stripe_pbk);
                        stripe
                            .redirectToCheckout({
                                sessionId: sessionId,
                            })
                            .then(function (result) {
                                if (result.error.message) {
                                    document.body.dispatchEvent(dataLoadComplete);

                                    return false;
                                }
                            });
                    })
                    .fail(function () {
                        document.body.dispatchEvent(dataLoadComplete);
                    });
            },
            toggleScrolling: function (enable = true) {
                if (enable) {
                    // $('body').unbind('touchmove');
                    $('body').removeClass('stop-scrolling');
                } else {
                    /*  $('body').bind('touchmove', function(e) {
                        e.preventDefault();
                    }); */
                    $('body').addClass('stop-scrolling');
                }
            },
            inputAutocomplete: function () {
                let country = $('#country').val(),
                    country_code;

                $('#state').val('');
                window.bhWP.stateCode = '';

                if (country) {
                    window.bhWP.prepareToDataLoad();

                    country_code = Object.keys(window.bhWP.countryList).find(
                        (key) => window.bhWP.countryList[key] === country
                    );
                    if (country_code) {
                        $.getJSON(wp.ajax_url + '?action=bhop_get_country_data&country_code=' + country_code)
                            .done((resp) => {
                                window.bhWP.selectedCountry = resp.data;
                            })
                            .always(() => {
                                document.body.dispatchEvent(dataLoadComplete);
                            });
                    } else {
                        $('#country').val('');
                        window.bhWP.selectedCountry = undefined;
                    }
                }
            },
            hideTopBar: function (hide = true) {
                if (hide) {
                    $('.bh-navbar').css('display', 'none');
                } else {
                    $('.bh-navbar').css('display', 'block');
                }
            },
            escapeRegExp: function (string) {
                // https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
                return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
            },
            codCheckout: function () {
                let formData = {};

                if (!$('.input-shipping-type').is(':checked')) {
                    $('#error-select-shipping').fadeIn();
                    $('form.checkout-form').scrollTop(0);
                    return false;
                }

                $('#checkout_form')
                    .serializeArray()
                    .forEach((element) => {
                        formData[element.name] = element.value;
                    });

                formData['country_id'] = '';

                if (window.bhWP.selectedCountry.country_id) {
                    formData['country_id'] = window.bhWP.selectedCountry.country_id;
                }
                formData['country_code'] = window.bhWP.selectedCountry.country_code;
                formData['state_code'] = window.bhWP.stateCode ? window.bhWP.stateCode : '';

                let requestData = {
                    action: 'bhop_handle_cod_payment',
                    formData: formData,
                };

                window.bhWP.prepareToDataLoad();

                $.post(wp.ajax_url, requestData, () => {}, 'json')
                    .done((resp) => {
                        if (!resp.result) {
                            document.body.dispatchEvent(dataLoadComplete);

                            return false;
                        }
                        document.body.dispatchEvent(dataLoadComplete);
                        window.location = wp.website_url + '/success/?id=' + resp.order_id + '&cod=1';
                    })
                    .fail(function () {
                        document.body.dispatchEvent(dataLoadComplete);
                    });
            },
        };
        document.body.addEventListener('dataLoadComplete', window.bhWP.dataLoaded);

        // Get plan info
        $.get('https://backend.boundaryhopper.com/api/plans', () => {})
            .done((result) => {
                try {
                    let resp = JSON.parse(result).data;
                    resp.forEach((v) => {
                        if (!(v.interval in bhWP.plans)) {
                            window.bhWP.plans[v.interval] = {};
                        }
                        window.bhWP.plans[v.interval][v.name] = {
                            price: v.cost,
                            features: v.meta.features,
                            save: v.meta.saving,
                        };
                    });
                    window.bhWP.setPlanData('yearly');
                    $('.plans-wrap').css('display', 'flex');
                } catch (err) {
                    $('.plans-wrap').css('display', 'none');

                    console.log(err);
                }
            })
            .fail(() => {});

        /**
         *
         * Get shipping info
         */
        window.bhWP.prepareToDataLoad();
        $.getJSON(wp.ajax_url + '?action=bhop_get_countries')
            .done((resp) => {
                if (!resp.data.status) {
                    window.bhWP.countryList = {};
                    return false;
                }
                window.bhWP.countryList = resp.data.country_list;
                document.body.dispatchEvent(dataLoadComplete);

                window.bhWP.inputAutocomplete();
            })
            .fail(() => {
                window.bhWP.countryList = {};
            });

        $.validate({
            form: '#checkout_form',
            onSuccess: window.bhWP.goToSelectShipping,
        });
        $('.select-shipping-btn').on('click', () => {
            $('#checkout_form').submit();
        });
        $('#checkout_form').on('submit', (e) => e.preventDefault());
        $('#submit_stripe').on('click', (e) => {
            e.preventDefault();

            if (window.bhWP.userDataFilled) {
                window.bhWP.goToCheckout();
            }
        });
        /* $('#state').on('validation', function(e, valid) {
            if (!valid) {
                $('#state').val('');
                if ($('#states_list').children().length) {
                    $('#states_list').fadeIn();
                }
            }
        });
        $('#country').on('validation', function(e, valid) {
            if (!valid) {
                $('#country').val('');
                if ($('#country_list').children().length) {
                    $('#country_list').fadeIn();
                }
            }
        }); */

        /**
         * Display mobile navbar box
         */
        $('#mob_navbar_btn').on('click', function () {
            if ($(this).hasClass('is-active')) {
                $('#navbar_mobile').slideUp();

                $(this).removeClass('is-active');
            } else {
                $('#navbar_mobile').css('display', 'flex').hide().slideDown();
                $(this).addClass('is-active');
            }
        });

        /**
         * Remove the modal when click on dark area
         *
         */
        $('.checkout-modal-wrap').on('click', function (e) {
            if ($(e.target).hasClass('checkout-modal-wrap')) {
                $('.checkout-modal-wrap').fadeOut();
                window.bhWP.toggleScrolling();
                window.bhWP.hideTopBar(false);
            }
            e.stopPropagation();
        });

        /**
         * Display list of contries on user input
         *
         */
        $('#country').on('input', function () {
            let $this = $(this),
                userInput = $this.val(),
                countryItems = '',
                countries = window.bhWP.getFiltered(userInput, window.bhWP.countryList);

            window.bhWP.selectedCountry = undefined;

            for (let key in countries) {
                countryItems += `<div class="bh-item" data-country-code=${key}>${countries[key]}</div>`;
            }
            if (countryItems) {
                $('#country_list')
                    .html($(countryItems))
                    .fadeIn(400, () => {
                        if ($('#country_list').children().length == 1) {
                            $('#country_list').children().first().click();
                        }
                    });
                // .css('display', 'block');
            }
        });
        /**
         * Display list of states on user input
         *
         */
        $('#state').on('input', function () {
            window.bhWP.stateCode = '';

            if (!window.bhWP.selectedCountry || !window.bhWP.selectedCountry.states) {
                return false;
            }
            let $this = $(this),
                userInput = $this.val(),
                stateItems = '',
                states = window.bhWP.getFiltered(userInput, window.bhWP.selectedCountry.states);

            for (let key in states) {
                stateItems += `<div class="bh-item" 
                                    data-state-name="${states[key]}" 
                                    data-state-code=${key}>${states[key]}</div>`;
            }
            if (stateItems) {
                $('#states_list').html($(stateItems)).fadeIn();
                /*   .fadeIn(400, () => {
                        if ($('#states_list').children().length == 1) {
                            $('#states_list').children().first().click();
                        }
                    }); */
            }
        });

        /**
         * User selects country from the list
         */
        $('#country_list').on('click', '.bh-item', function () {
            let $this = $(this),
                country_code = $(this).data('country-code');
            if (!country_code) {
                return false;
            }

            // $this.parent().css('display', 'none');
            $this.parent().fadeOut();
            $('input#country').val($this.html());

            $('#states_list').fadeOut();

            window.bhWP.prepareToDataLoad();
            $.getJSON(wp.ajax_url + '?action=bhop_get_country_data&country_code=' + country_code)
                .done((resp) => {
                    window.bhWP.selectedCountry = resp.data;
                })
                .always(() => document.body.dispatchEvent(dataLoadComplete));
        });
        /**
         * User selects state from the list
         */
        $('#states_list').on('click', '.bh-item', function () {
            let $this = $(this);
            $this.parent().fadeOut();
            $('input#state').val($this.html());
            window.bhWP.stateCode = $this.data('state-code');
        });

        /**
         * User selects shipping method
         *
         */
        $('input[name=shipping]').on('change', function (e) {
            if (!window.bhWP.selectedCountry) {
                return false;
            }
            $('#error-select-shipping').hide();
            $('#total_cost').html(`$${window.bhWP.calculatePrice()}`);

            e.stopPropagation();
        });

        /**
         * handle quantity input near the product slider
         */
        $('#main_qty_add').on('click', function (e) {
            let qty = Number($('input#main_product_qty').val());
            if (isNaN(qty) || qty < 1) {
                qty = 1;
            } else {
                qty++;
            }
            $('input#main_product_qty').val(qty);
        });
        $('#main_qty_remove').on('click', function (e) {
            let qty = Number($('input#main_product_qty').val());
            if (isNaN(qty) || qty <= 1) {
                qty = 1;
            } else {
                qty--;
            }
            $('input#main_product_qty').val(qty);
        });

        /**
         * User updates quantity
         */

        $('#qty_add').on('click', function (e) {
            let qty = Number($('input#product_qty').val());
            if (isNaN(qty) || qty < 1) {
                qty = 1;
            } else {
                qty++;
            }
            $('input#product_qty').val(qty);
            $('#total_cost').html(`$${window.bhWP.calculatePrice()}`);
        });
        $('#qty_remove').on('click', function (e) {
            let qty = Number($('input#product_qty').val());
            if (isNaN(qty) || qty <= 1) {
                qty = 1;
            } else {
                qty--;
            }
            $('input#product_qty').val(qty);
            $('#total_cost').html(`$${window.bhWP.calculatePrice()}`);
        });

        /**
         * Create stripe session for a product
         */
        $('.buy-product-btn').on('click', function () {
            let productId = $(this).data('product-id');
            $('.checkout-modal-wrap').css('display', 'flex').hide().fadeIn();
            window.bhWP.toggleScrolling(false);
            window.bhWP.hideTopBar();
            /* window.bhWP = {
                ...window.bhWP,
                selectedCountry: undefined,
                userDataFilled: false,
            }; */
            $('#product_id').val(productId);
            $('.go-to-checkout').css('display', 'none');
            $('.user-details-wrap').css('display', 'block');

            window.bhWP.sendConversionInitCheckout();

            window.bhWP.prepareToDataLoad();

            if (productId in window.bhWP.productsCache) {
                window.bhWP.currentProductPrice = window.bhWP.productsCache[productId].price;
                $('#product_title').html(window.bhWP.productsCache[productId].title);
                $('#total_cost').html(`$${window.bhWP.currentProductPrice}`);
                document.body.dispatchEvent(dataLoadComplete);
            } else {
                $.getJSON(`${wp.ajax_url}?action=bhop_get_product&id=${productId}`)
                    .done((resp) => {
                        if (!resp.data.status) {
                            return false;
                        }
                        window.bhWP.currentProductPrice = resp.data.price;

                        $('#product_title').html(resp.data.title);
                        $('#total_cost').html(`$${window.bhWP.currentProductPrice}`);

                        window.bhWP.productsCache[productId] = {
                            price: resp.data.price,
                            title: resp.data.title,
                        };
                    })
                    .always(() => document.body.dispatchEvent(dataLoadComplete));
            }
        });

        /**
         *
         * Handle coupons
         */
        $('#apply_coupon').on('click', (e) => {
            let code = $('input#coupon').val();
            $.post(
                wp.ajax_url,
                {
                    action: 'bhop_apply_coupon',
                    code,
                },
                () => {},
                'json'
            ).done((resp) => {
                if (!resp.data.status) {
                    $('#error-coupon').html(resp.data.message || 'Error while applying coupon.');
                    return false;
                }
                if (window.bhWP.couponApplied) {
                    $('#error-coupon').html("Sorry, you can't apply the coupon twice.");
                    return false;
                }
                let type = resp.data.coupon_type,
                    amount = 0,
                    currentPrice = window.bhWP.currentProductPrice;

                if (isNaN(Number(resp.data.coupon_amount))) {
                    return false;
                } else {
                    amount = Number(resp.data.coupon_amount);
                }

                if (type === 'percent') {
                    amount = (currentPrice / 100) * amount;
                }
                window.bhWP.couponApplied = true;
                window.bhWP.discount = amount;

                $('#applied_coupon').val(code);
                $('.input-coupon input#coupon, .input-coupon button').prop('disabled', true);
                $('#total_cost').html(`$${window.bhWP.calculatePrice()}`);
            });
        });

        $('.slider').slick({
            prevArrow: $('.nav-arrow-prev'),
            nextArrow: $('.nav-arrow-next'),
            adaptiveHeight: true,
            centerPadding: '10px',
            centerMode: true,
        });

        $('.video-modal').on('click', (e) => {
            if (e.target.classList.contains('video-container') || e.target.classList.contains('close-video')) {
                $('#bhVideoFrame').attr('src', '');
                $('.video-modal').css('display', 'none');
            }
        });
        $('.watch-video-btn').on('click', () => {
            if (!$('#bhVideoFrame').attr('src') || !$('#bhVideoFrame').attr('src').length) {
                $('#bhVideoFrame').attr('src', BH_VIDEO_URL);
            }
            $('.video-modal').css('display', 'flex');
            $('.video-modal').find('iframe').click();
        });

        $('#product_2_note_icon').on({
            mouseenter: (event) => {
                let $this = $(event.target),
                    $note = $('.product-2-note'),
                    w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

                let pageY = $this.offset().top - $note.innerHeight() - 15,
                    pageX = $this.offset().left;
                if (w >= 1300) {
                    $note.find('.bottom-arrow').css('left', '4px');
                } else if (w < 440) {
                    $note.find('.bottom-arrow').css('left', pageX - 8);
                    pageX = 10;
                } else {
                    pageX = pageX - $note.innerWidth() + 20;
                    $note.find('.bottom-arrow').css('left', '18.4375rem');
                }

                $note.css('display', 'block').css('top', `${pageY}px`).css('left', `${pageX}px`);
            },
            mouseleave: () => {
                $('.product-2-note').css('display', 'none');
            },
        });

        $('.plan').click(function (e) {
            e.preventDefault();
            $('.plan').removeClass('selected');
            $(this).addClass('selected');
        });
        $('.plan button').click(function (e) {
            e.preventDefault();
            $('.buy_now_btn').click();
        });
        $('#plan_switch, #plan_switch .switcher').on('click', function (e) {
            e.stopPropagation();

            let $self = $(e.target);
            if ($self.hasClass('circle')) {
                $self = $self.parent();
            }

            if ($self.hasClass('yearly')) {
                bhWP.setPlanData('monthly');
                $('.save-label').hide();
                $self.removeClass('yearly');
                $self.addClass('monthly');
                $self.parent().find('.plan-title-yearly').addClass('transpar');
                $self.parent().find('.plan-title-monthly').removeClass('transpar');
            } else {
                bhWP.setPlanData('yearly');
                $('.save-label').show();
                $self.removeClass('monthly');
                $self.addClass('yearly');
                $self.parent().find('.plan-title-monthly').addClass('transpar');
                $self.parent().find('.plan-title-yearly').removeClass('transpar');
            }
        });

        $('button#submit_cod').on('click', window.bhWP.codCheckout);
    });
})(jQuery);

// $('.input-express-shipping input[type=radio]').prop('checked', true);

// if specific country, replace FREE SHIPPING with CASH ON DELIVERY
// if (window.bhWP.selectedCountry && window.bhWP.selectedCountry.country_code === 'AE') {
//     $('#free_shipping_item').hide();

//     $('#cod_shipping').show();

//     if ($('.input-express-shipping input[type=radio]').prop('checked')) {
//         $('#submit_cod_btn').hide();
//         $('#submit_paypal_btn, #submit_stripe_btn').show();
//     }

// } else {
//     $('#free_shipping_item').show();
//     $('#submit_paypal_btn, #submit_stripe_btn').show();

//     $('#cod_shipping').hide();
//     $('#submit_cod_btn').hide();
// }
// let standart = window.bhWP.selectedCountry.shipping.free_delivery_time,
/* expressDelivery = window.bhWP.selectedCountry.shipping.express_delivery_time,
                    expressPrice = window.bhWP.selectedCountry.shipping.price,
                    codPrice = window.bhWP.selectedCountry.shipping.cod_price; */
/*     // handle Cash On Pay for UAE
                if (codPrice == 0) {
                    $('.input-cod-shipping').css('display', 'none');
                } else {
                    $('.shipping-desc#cod_price .shipping-desc-val').html(`$${codPrice}`);
                }

                if (expressPrice == 0) {
                    $('.input-express-shipping').css('display', 'none');
                } else {
                    $('.shipping-desc#express_post .shipping-desc-val').html(
                        `${window.bhWP.formatDelivery(expressDelivery)}`
                    );
                    $('.shipping-desc#express_price .shipping-desc-val').html(`$${expressPrice}`);

                }


                $('.shipping-desc#free .shipping-desc-val').html(`${window.bhWP.formatDelivery(freeDelivery)}`); */

(($) => {
    $(document).ready(() => {
        // PRODUCT PHOTOS SLIDER
        $('.slider-content').slick({
            prevArrow: $('.photo-prev'),
            nextArrow: $('.photo-next'),
            adaptiveHeight: true,
            centerMode: false,
            /* responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '16px',
                        slidesToShow: 1,
                    },
                },
            ], */
        });
    });
})(jQuery);
